import { GBR_STATUS } from '@/helpers/bankAttachmentTypes';
import { toProjectBankInput } from './projectBankInput';

/**
 * `Project.bank` fields saved by the block project-bank-customer. Must match
 * `ProjectBankCustomerInput` in the API schema.
 */
export const PROJECT_BANK_CUSTOMER_INPUT_FIELDS = ['prospectiveCustomer', 'gbrStatus'];

/**
 * `ProjectBankCustomerInput` from the block object. A missing GbR status is sent as NONE, the
 * value the tab has always shown for it.
 */
export const toProjectBankCustomerInput = (project) => {
  const input = toProjectBankInput(project, PROJECT_BANK_CUSTOMER_INPUT_FIELDS);

  return { ...input, gbrStatus: input.gbrStatus ?? GBR_STATUS.NONE };
};
